module.exports = __webpack_public_path__ + "img/checkout-vest.cdf220e5.svg";